export enum LOCK_CONDITIONS_ENUM {
  afterReservationCreatedEnabled = 'is_smart_lock_email_after_reservation_created_enabled',
  afterAllGuestsRegisteredEnabled = 'is_smart_lock_email_after_all_guests_registered_enabled',
  afterLeadGuestRegisteredEnabled = 'is_smart_lock_email_after_lead_guest_registered_enabled',
  afterAllPaymentsComplete = 'is_smart_lock_email_after_all_payments_complete',
  allPaymentAndAllGuestsRegistered = 'is_smart_lock_email_all_payment_and_all_guests_registered',
  afterLeadGuestPassedBiomatchEnabled = 'is_smart_lock_email_after_lead_guest_passed_biomatch_enabled',
  afterAllGuestsPassedBiomatchEnabled = 'is_smart_lock_email_after_all_guests_passed_biomatch_enabled',
  allPaymentAndLeadGuestsIdentified = 'is_smart_lock_email_all_payment_and_lead_guests_identified',
  allPaymentAndAllGuestsIdentified = 'is_smart_lock_email_all_payment_and_all_guests_identified',
}

export enum LOCK_TIMING_CONDITIONS_ENUM {
  oneWeekBeforeCheckInEnabled = 'is_smart_lock_email_one_week_before_check_in_enabled',
  checkIn72HoursBeforeEnabled = 'is_smart_lock_email_72_hours_before_check_in_enabled',
  checkIn48HoursBeforeEnabled = 'is_smart_lock_email_48_hours_before_check_in_enabled',
  checkIn24HoursBeforeEnabled = 'is_smart_lock_email_24_hours_before_check_in_enabled',
  smartLockInitRangeDays = 'smart_lock_init_range_days',
}

export type BOOLEAN_TIMING_CONDITIONS_ENUM = Exclude<
  LOCK_TIMING_CONDITIONS_ENUM,
  typeof LOCK_TIMING_CONDITIONS_ENUM.smartLockInitRangeDays
>;

const LOCKS_CONDITIONS = [
  ...Object.values(LOCK_CONDITIONS_ENUM),
  ...Object.values(LOCK_TIMING_CONDITIONS_ENUM),
];
const TIMING_VALIDATIONS = [
  LOCK_TIMING_CONDITIONS_ENUM.oneWeekBeforeCheckInEnabled,
  LOCK_TIMING_CONDITIONS_ENUM.checkIn72HoursBeforeEnabled,
  LOCK_TIMING_CONDITIONS_ENUM.checkIn48HoursBeforeEnabled,
  LOCK_TIMING_CONDITIONS_ENUM.checkIn24HoursBeforeEnabled,
  LOCK_TIMING_CONDITIONS_ENUM.checkIn24HoursBeforeEnabled,
  LOCK_TIMING_CONDITIONS_ENUM.smartLockInitRangeDays,
];

// const PAYMENT_VALIDATIONS = [
//   LOCK_CONDITIONS_ENUM.allPaymentAndAllGuestsIdentified,
//   LOCK_CONDITIONS_ENUM.allPaymentAndAllGuestsRegistered,
//   LOCK_CONDITIONS_ENUM.allPaymentAndLeadGuestsIdentified,
//   LOCK_CONDITIONS_ENUM.afterAllPaymentsComplete,
// ];
const smartLockHoursBeforeCheckin = {
  [LOCK_TIMING_CONDITIONS_ENUM.oneWeekBeforeCheckInEnabled]: 168,
  [LOCK_TIMING_CONDITIONS_ENUM.checkIn72HoursBeforeEnabled]: 72,
  [LOCK_TIMING_CONDITIONS_ENUM.checkIn48HoursBeforeEnabled]: 48,
  [LOCK_TIMING_CONDITIONS_ENUM.checkIn24HoursBeforeEnabled]: 24,
};

export {smartLockHoursBeforeCheckin, LOCKS_CONDITIONS, TIMING_VALIDATIONS};
